import { Link } from 'react-router-dom';
import { featuredManhwa } from '@/mocks/home';

export default function FeaturedList() {
  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-3 mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-3">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              本周热门韩漫精选
            </h2>
          </div>
          <Link
            to="/category/romance"
            className="flex items-center gap-1 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredManhwa.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.id}`}
              className="group cursor-pointer"
            >
              {/* Cover Image */}
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden mb-3 bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {/* Rating Badge */}
                <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/60 backdrop-blur-sm rounded-md flex items-center gap-1">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span className="text-white text-xs font-medium">{item.rating}</span>
                </div>
                {/* Views */}
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/70 to-transparent">
                  <span className="text-white/80 text-xs">
                    <i className="ri-eye-line mr-1"></i>
                    {item.views}
                  </span>
                </div>
              </div>

              {/* Info */}
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-1">
                {item.title}
              </h3>
              <p className="text-foreground-500 text-xs line-clamp-1 mb-2">{item.author}</p>
              <div className="flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-md text-xs"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}